import util from '@/common/util';

const reg_youtube_link = /www\.youtube\.com\/watch\?.*v=([^&]+)/;
const reg_youtube_share_link = /youtu\.be\/([^\/]+)$/;
const reg_youtube_embed_link = /www\.youtube\.com\/embed\/([^\/]+)$/;

let youtubePs;

export default {
    getYoutubeId(src) {
        let videoId = '';
        if (reg_youtube_link.test(src)) {
            videoId = src.match(reg_youtube_link)[1];
        }
        if (reg_youtube_share_link.test(src)) {
            videoId = src.match(reg_youtube_share_link)[1];
        }
        if (reg_youtube_embed_link.test(src)) {
            videoId = src.match(reg_youtube_embed_link)[1];
        }
        return videoId;
    },
    prepare() {
        if (!youtubePs) {
            youtubePs = new Promise(res => {
                util.getUserActionPs().then(() => {
                    util.addScript('https://www.youtube.com/iframe_api');
                    window.onYouTubeIframeAPIReady = () => {
                        res();
                    };
                });
            });
        }
        return youtubePs;
    }
};
